/**
 * Hook for role label utilities with org context.
 */

import { useCallback, useMemo } from "react";
import { useAppContext } from "../context/AppContext";
import type { RoleLabelsByKey, USER_TYPE } from "../object-actions/types/types";
import { applyRoleLabels, getRoleDisplayLabel, getUserTypeLabel } from "../utils/roleLabels";

export function useRoleLabels() {
  const { organization } = useAppContext();
  const labels = organization?.role_labels ?? null;

  const apply = useCallback(
    (text: string) => applyRoleLabels(text, labels),
    [labels]
  );

  const getLabel = useCallback(
    (roleKey: keyof RoleLabelsByKey, options?: { plural?: boolean }) =>
      getRoleDisplayLabel(labels, roleKey, options),
    [labels]
  );

  const getTypeLabel = useCallback(
    (userType: USER_TYPE) => getUserTypeLabel(labels, userType),
    [labels]
  );

  return useMemo(
    () => ({
      labels,
      applyRoleLabels: apply,
      getRoleLabel: getLabel,
      getUserTypeLabel: getTypeLabel,
    }),
    [labels, apply, getLabel, getTypeLabel]
  );
}
